// extracted by mini-css-extract-plugin
export default {"div":"Login_div__FwBQU","form":"Login_form__lSOgB","input":"Login_input__hSwOr","p":"Login_p__ZyDwz","label":"Login_label__LyoiM"};